export const keys = {
  list: () => ['nutrition-plans', 'list'] as const,
  mutations: {
    create: () => ['nutrition-plans', 'mutations', 'create'] as const,
    update: () => ['nutrition-plans', 'mutations', 'update'] as const,
    delete: () => ['nutrition-plans', 'mutations', 'delete'] as const,
  },
} as const;
